import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box, Flex } from '../../../../units/Box/Box';
import Text from '../../../../units/Text/Text';
import Button from '../../../../units/Button/Button';

import FormInput from '../../FormControls/FormInput/FormInput';
import FormCheckbox from '../../FormControls//FormCheckbox/FormCheckbox';

import { FormTitle } from '../../FormUnits/FormUnits';

import withForm from '../../../../hocs/withForm';

const Link = styled(Text)`
  color: ${props => props.theme.colors.link};
  text-decoration: underline;
`;

const InputWrapper = styled(Box).attrs({
  mb: '20px'
})``;

const FormActions = {
  next: {
    actionId: 'next',
    isActionSubmit: true
  }
};

class RegistratUserForm extends Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    getFieldProps: PropTypes.func.isRequired,
    getActionProps: PropTypes.func.isRequired,
    applyAction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired
  };

  saveForm = values => {
    this.props.applyAction({
      actionId: 'next',
      values
    });
  };

  showAgreement = e => {
    e.preventDefault();

    this.props.applyAction({
      actionId: 'showAgreement'
    });
  };

  showPersonalInfo = e => {
    e.preventDefault();

    this.props.applyAction({
      actionId: 'showPersonalInfo'
    });
  };

  render() {
    const { getFieldProps, getActionProps, params } = this.props;

    return (
      <Flex align="center" column className="zeroClient_step_registration">
        <FormTitle className="form-title_user-information">
          Укажите контактную информацию
        </FormTitle>

        <Flex align="flex-end" column>
          <Box>
            <InputWrapper>
              <FormInput
                width="400px"
                label="ФИО"
                autoFocus
                {...getFieldProps('name')}
              />
            </InputWrapper>

            <InputWrapper>
              <FormInput
                width="400px"
                label="Телефон"
                {...getFieldProps('phone')}
              />
            </InputWrapper>

            <InputWrapper>
              <FormInput
                label="Почта"
                placeholder="example@mail.ru"
                width="400px"
                {...getFieldProps('email')}
              />
            </InputWrapper>
          </Box>

          <Box width="400px">
            <Box mb="30px">
              <Box mb="10px">
                <FormCheckbox
                  label={
                    <Text>
                      Я согласен{' '}
                      <Link onClick={this.showPersonalInfo}>
                        {params.personalInfoLabel}
                      </Link>
                    </Text>
                  }
                  {...getFieldProps('checkPersonalInfo')}
                />
              </Box>
              <Box>
                <FormCheckbox
                  label={
                    <Text>
                      Я согласен{' '}
                      <Link onClick={this.showAgreement}>
                        {params.agreementLabel}
                      </Link>
                    </Text>
                  }
                  {...getFieldProps('checkAgreement')}
                />
              </Box>
            </Box>

            <Button
              size="large"
              font="caption"
              onClick={this.props.handleSubmit(this.saveForm)}
              bold
              {...getActionProps(FormActions.next)}
            >
              Далее
            </Button>
          </Box>
        </Flex>
      </Flex>
    );
  }
}

export default withForm(RegistratUserForm);



// WEBPACK FOOTER //
// ./src/components/containers/Forms/FormsComponents/RegistratUser/RegistratUser.js